"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _dateFns = require("date-fns");
var _de = require("date-fns/locale/de");
var _nachweisTypConstants = require("./nachweisTypConstants");
var getWeekStartFormat = function getWeekStartFormat(start, end) {
  var format = 'dd.';
  if ((0, _dateFns.getMonth)(start) !== (0, _dateFns.getMonth)(end)) {
    format = format + 'MM.';
  }
  if ((0, _dateFns.getYear)(start) !== (0, _dateFns.getYear)(end)) {
    format = format + 'yy';
  }
  return format;
};
var formatLocalised = function formatLocalised(date, formatString) {
  return (0, _dateFns.format)(date, formatString, {
    locale: _de.de
  });
};
var getWeekString = function getWeekString(mainDate) {
  var startWeek = (0, _dateFns.startOfWeek)(mainDate, {
    weekStartsOn: 1
  });
  var endWeek = (0, _dateFns.endOfWeek)(mainDate, {
    weekStartsOn: 1
  });
  var startDate = formatLocalised(startWeek, getWeekStartFormat(startWeek, endWeek));
  var endDate = formatLocalised(endWeek, 'dd.MM.yy');
  return "".concat(startDate, "-").concat(endDate);
};
var getAusbildungStartDateForNachweis = function getAusbildungStartDateForNachweis(nachweis, userSettings) {
  if (!nachweis || !userSettings || !userSettings.ausbildungsstart) {
    return undefined;
  }
  return userSettings.ausbildungsstart;
};
var _default = exports["default"] = {
  getFormattedDateRange: function getFormattedDateRange(nachweis, userInfo) {
    var startDate = getAusbildungStartDateForNachweis(nachweis, userInfo);
    if (!startDate) return undefined;
    if (userInfo.ausbildungsnachweisTyp === _nachweisTypConstants.nachweisTypes.MONTHLY) {
      return (0, _dateFns.format)(nachweis.periodStart, 'MMM yy', {
        locale: _de.de
      });
    } else {
      return "".concat(getWeekString(nachweis.periodStart));
    }
  }
};